import React, { useState, useEffect } from 'react';
import {Layout, Menu, theme, Button} from 'antd';
import {
    MenuFoldOutlined,
    MenuUnfoldOutlined
} from '@ant-design/icons';
import { useLocation, useNavigate } from 'react-router-dom';
import { authService } from '../../services/api';
import {
    IconIdentityCard,
    IconLabelPrinter,
    IconOrder,
    IconPointOfSale,
    IconUser, IconWallet
} from "../../../../components/icons/index";

const { Sider } = Layout;

const SideMenu = ({ onCollapse }) => {
    const {
        token: { colorBgContainer },
    } = theme.useToken();
    const navigate = useNavigate();
    const location = useLocation();

    const [collapsed, setCollapsed] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    const [mobileSiderVisible, setMobileSiderVisible] = useState(false);

    const [openKeys, setOpenKeys] = useState(['company']);

    useEffect(() => {
        const checkMobile = () => setIsMobile(window.innerWidth < 768);
        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    useEffect(() => {
        if (onCollapse) {
            onCollapse(collapsed);
        }
    }, [collapsed, onCollapse]);

    const getSelectedKey = () => {
        const path = location.pathname;
        if (path === '/sales' || path.startsWith('/sales/')) return ['sales'];
        if (path === '/cash-registers' || path.startsWith('/cash-registers/')) return ['cash-registers'];
        if (path === '/cashiers' || path.startsWith('/cashiers/')) return ['cashiers'];
        if (path === '/fiscal-cash-registers' || path.startsWith('/fiscal-cash-registers/')) return ['fiscal-cash-registers'];
        if (path === '/payment-methods' || path.startsWith('/payment-methods/')) return ['payment-methods'];
        if (path === '/customers' || path.startsWith('/customers/')) return ['customers'];
        return [];
    };

    const toggleCollapsed = () => {
        isMobile ? setMobileSiderVisible(!mobileSiderVisible) : setCollapsed(!collapsed);
    };

    const menuItems = [
        authService.hasPermission('pos:sales:view') && {
            key: 'sales',
            icon: <span className="anticon" style={{fontSize: '18px'}}><IconOrder/></span>,
            label: 'Продажи',
            onClick: () => navigate('/sales'),
        },

        authService.hasPermission('pos:customers:view') && {
            key: 'customers',
            icon: <span className="anticon"  style={{ fontSize: '16px' }}><IconUser/></span>,
            label: 'Клиенты',
            onClick: () => navigate('/customers'),
        },

        authService.hasPermission('pos:cash_registers:view') && {
            key: 'cash-registers',
            icon: <span className="anticon" style={{fontSize: '18px'}}><IconPointOfSale/></span>,
            label: 'Кассы',
            onClick: () => navigate('/cash-registers'),
        },

        authService.hasPermission('pos:cashiers:view') && {
            key: 'cashiers',
            icon: <span className="anticon" style={{fontSize: '18px'}}><IconIdentityCard/></span>,
            label: 'Кассиры',
            onClick: () => navigate('/cashiers'),
        },

        authService.hasPermission('pos:fiscal_cash_registers:view') && {
            key: 'fiscal-cash-registers',
            icon: <span className="anticon" style={{fontSize: '18px'}}><IconLabelPrinter/></span>,
            label: 'Фискальные кассы',
            onClick: () => navigate('/fiscal-cash-registers'),
        },

        authService.hasPermission('pos:payment_methods:view') && {
            key: 'payment-methods',
            icon: <span className="anticon" style={{fontSize: '18px'}}><IconWallet/></span>,
            label: 'Способы оплаты',
            onClick: () => navigate('/payment-methods'),
        }
    ].filter(Boolean);

    if (isMobile) {
        return (
            <>
            <Button
                    type="primary"
                    onClick={toggleCollapsed}
                    style={{ position: 'fixed', right: 24, bottom: 24, zIndex: 1001 }}
                    icon={mobileSiderVisible ? <MenuFoldOutlined /> : <MenuUnfoldOutlined />}
                />
                {mobileSiderVisible && (
                    <div
                        style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(0, 0, 0, 0.45)', zIndex: 999 }}
                        onClick={() => setMobileSiderVisible(false)}
                    />
                )}
                <Sider
                    width={250}
                    style={{ background: colorBgContainer, overflow: 'auto', height: '100vh', position: 'fixed', left: mobileSiderVisible ? 0 : -250, transition: 'all 0.2s', zIndex: 1000 }}
                >
                    <Menu mode="inline"
                          selectedKeys={getSelectedKey()}
                          openKeys={openKeys}
                          onOpenChange={setOpenKeys}
                          items={menuItems}
                          style={{padding: '8px'}}/>
                </Sider>
            </>
        );
    }

    return (
        <Sider width={260} collapsible collapsed={collapsed} trigger={null} collapsedWidth={80} style={{ background: colorBgContainer, overflow: 'auto', height: 'calc(100vh - 64px)', position: 'fixed', left: 0, top: 64 }}>
            <Menu mode="inline"
                  selectedKeys={getSelectedKey()}
                  openKeys={openKeys}
                  onOpenChange={setOpenKeys}
                  items={menuItems}
                  style={{padding: '8px'}}/>
            <div style={{ position: 'absolute', bottom: 0, width: '100%', padding: '12px', textAlign: 'right', borderTop: '1px solid rgba(139, 139, 139, 0.35)' }}>
                <Button type="text" onClick={toggleCollapsed} icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />} />
            </div>
        </Sider>
    );
};

export default SideMenu;
